const ROAMR_API_URL = process.env.REACT_APP_ROAMR_API_URL;
const API_HOST_V1 = `${ROAMR_API_URL}/v1`;
const API_HOST_V2 = `${ROAMR_API_URL}/v2`;
const API_HOST_V3 = `${ROAMR_API_URL}/v3`;

export const getOperatorData = async (operatorId) => {
  const url = `${API_HOST_V1}/web-startup?` + new URLSearchParams({
    operator: operatorId,
  });
  return fetch(url, {
    headers: {
      'Content-Type': 'application/JSON',
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json().then(data => {
        //console.log('getOperatorData response:', data);
        return data;
      });
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
  .catch((error) => {
    console.error(error);
    throw error;
  });
};

export const requestCode = async (phone, countryCode) => {
  const url = `${API_HOST_V1}/requestCode`; 
  const body = {
    phone,
    country_code: countryCode,
  };
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to send SMS code. Please try again.');
    }
  })
  .catch((error) => {
    console.error(error);
    throw error;
  });
};

export const createCheckoutSession = async (params) => {
  const url = `${API_HOST_V3}/reservation-web/create-checkout-session`;
  
  console.log('createCheckoutSession - URL:', url);
  console.log('createCheckoutSession - Params:', params);
  
  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(async (response) => {
    console.log('createCheckoutSession - Response status:', response.status);
    console.log('createCheckoutSession - Response ok:', response.ok);
    
    if (response.ok) {
      const data = await response.json();
      console.log('createCheckoutSession - Success data:', data);
      return data;
    } else {
      // Parse error response for better error handling
      let errorData;
      try {
        errorData = await response.json();
      } catch {
        const errorText = await response.text();
        console.error('createCheckoutSession - Error response (text):', errorText);
        throw new Error(`Failed to create checkout session. Status: ${response.status}`);
      }
      
      console.error('createCheckoutSession - Error response:', errorData);
      
      // Handle specific error types
      if (errorData.title === 'Price Mismatch') {
        const error = new Error(`Price Mismatch: Frontend amount $${errorData.frontend_total} doesn't match calculated amount $${errorData.calculated_total}`);
        error.errorData = errorData;
        throw error;
      }
      
      // Throw error with the backend message
      throw new Error(errorData.message || errorData.title || 'Failed to create checkout session');
    }
  })
  .catch((error) => {
    console.error('createCheckoutSession - Catch error:', error);
    throw error;
  });
};

export const checkVehicleAvailable = async (vehicle_type, fleet_id, start_date, end_date) => {
  const url = `${API_HOST_V3}/reservation-web/check-vehicle-available?` + new URLSearchParams({
    vehicle_type,
    fleet_id,
    start_date,
    end_date
  });

  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return true;
    } else if (response.status === 404) {
      return response.json().then(errorData => {
        throw new Error(errorData.message || 'Vehicles unavailable');
      });
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const signUp = async (country_code, phone, code, operatorId) => {
  const url = `${API_HOST_V1}/signup`;
  const body = {
    password: 'password', 
    country_code,
    phone,
    code,
    operator_id: operatorId,
    account_type: 'user',
    fromWebApp: true
  };

  return fetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/JSON',
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to sign in. Please try again.');
    }
  })
  .catch((error) => {
    console.error(error);
    throw error;
  });
};

export const getFleets = (operatorId) => {
  const url = `${API_HOST_V2}/reservation-web/fleets?`+ new URLSearchParams({
    operator_id: operatorId,
  });
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  }).then((data) => {
    // Filter to only include fleets with type 'reservation'
    if (data && data.fleets && Array.isArray(data.fleets)) {
      const reservationFleets = data.fleets.filter(fleet => fleet.type === 'reservation');
      return { ...data, fleets: reservationFleets };
    }
    return data;
  });
};


export const getPrice = (fleet_id, start_date, end_date, vehicle_type, coupon_id, addon_ids, qty = 1) => {
  let params = {
    start_date,
    end_date,
    fleet_id, 
    vehicle_type,
  };
  if (coupon_id) {
    params.coupon_id = coupon_id;
  }
  if (addon_ids && addon_ids.length > 0) {
    params.addon_ids = addon_ids.join(',');
  }
  if (qty && qty !== 1) {
    params.qty = qty;
  }
  const url = `${API_HOST_V3}/reservation-web/reservation-price?` + new URLSearchParams(params);
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getFleet = async (fleetId) => {
  const url = `${API_HOST_V2}/reservation-web/fleet?`+ new URLSearchParams({
    fleet_id: fleetId,
  });
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  })
};


export const getFleetVehicles = (fleetId) => {
  const url = `${API_HOST_V2}/reservation-web/vehicles?`;
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getCoupon = (fleetId, code) => {
  const url = `${API_HOST_V3}/reservation-web/coupon?`+ new URLSearchParams({
    fleet_id: fleetId,
    code
  });
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    console.log("response:", response)
    if (response.ok) {
      return response;
    } else {
      throw new Error('There was a problem with your request. Please try again later');
    }
  });
};

export const getReservationSurcharges = (operatorId, fleet_fare_id) => {
  const url = `${API_HOST_V3}/reservation-web/surcharges?` + new URLSearchParams({
    operator_id: operatorId,
    fleet_fare_id: fleet_fare_id
  });
  return fetch(url, {
    method: 'GET',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to fetch reservation surcharges');
    }
  });
};

export const getAvailableVehicleTypes = async (fleet_id, start_date, end_date) => {
  const params = {
    fleet_id,
    start_date,
    end_date
  };
  const url = `${API_HOST_V3}/reservation-web/available-vehicle-types?` + new URLSearchParams(params);
  
  console.log('getAvailableVehicleTypes - URL:', url);
  console.log('getAvailableVehicleTypes - Params:', params);
  
  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(async (response) => {
    console.log('getAvailableVehicleTypes - Response status:', response.status);
    console.log('getAvailableVehicleTypes - Response ok:', response.ok);
    
    if (response.ok) {
      const data = await response.json();
      console.log('getAvailableVehicleTypes - Success data:', data);
      return data;
    } else {
      const errorText = await response.text();
      console.error('getAvailableVehicleTypes - Error response:', errorText);
      throw new Error(`Failed to fetch available vehicle types. Status: ${response.status}, Error: ${errorText}`);
    }
  })
  .catch((error) => {
    console.error('getAvailableVehicleTypes - Catch error:', error);
    throw error;
  });
};

export const getWaiverTemplate = async (operatorId, fleetId, userId) => {
  const params = {};
  
  // Add parameters that are provided
  if (operatorId) {
    params.operator_id = operatorId;
  }
  
  if (fleetId) {
    params.fleet_id = fleetId;
  }
  
  if (userId) {
    params.user_id = userId;
  }
    // Check if at least one parameter is provided
  if (Object.keys(params).length === 0) {
    return Promise.reject(new Error('No parameters provided, at least one of operatorId, fleetId, or userId is required'));
  }
  
  const url = `${API_HOST_V3}/reservation-web/waiver-template?` + new URLSearchParams(params);
    return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Failed to fetch waiver template');
    }
  })
  .catch((error) => {
    throw error;
  });
};

// Keeping the old function for backward compatibility but implementing using the new endpoint
export const getReservationAddons = (operatorId, fleet_fare_id) => {
  return getReservationSurcharges(operatorId, fleet_fare_id)
    .then(surcharges => {
      // Filter surcharges to only include those with surcharge_type='reservation_addon'
      // The response is already an array of surcharges
      const addons = Array.isArray(surcharges) ? 
        surcharges.filter(surcharge => surcharge.surcharge_type === 'reservation_addon') : 
        [];
      return { addons };
    });
};

export const submitWaiver = async (userId, submitData) => {
  const url = `${API_HOST_V3}/reservation-web/submit-waiver/${userId}`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(submitData),
  })
    .then(async (response) => {
      if (response.ok) {
        return response.json();
      } else {
        // Handle specific error cases
        if (response.status === 413) {
          throw new Error('Your photos are too large. Please try uploading smaller images or compress them before submitting.');
        } else if (response.status === 400) {
          // Try to get error details from response
          try {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Invalid waiver data. Please check your entries and try again.');
          } catch (e) {
            throw new Error('Invalid waiver data. Please check your entries and try again.');
          }
        } else if (response.status === 500) {
          throw new Error('Server error occurred. Please try again later or contact support.');
        } else {
          // Generic error for other status codes
          throw new Error(`Failed to submit waiver (Error ${response.status}). Please try again.`);
        }
      }
    })
    .catch((error) => {
      console.error('submitWaiver error:', error);
      throw error;
    });
};


